import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'

export const ContentRangScore = ({ data }) => {
  const checkOr = (index, length) => {
    if (index === 0 && length > 1) return true
    if (index !== 0 && index !== length - 1) return true

    return false
  }

  return (
    <div className="dFlex alignItemsCenter gap1 flexWrap">
      {data.map((item, index) => (
        <ItemScore
          key={index}
          item={item}
          isOr={checkOr(index, data?.length)}
        />
      ))}
    </div>
  )
}

export const ItemScore = ({ item, isOr }) => {
  return (
    <Element className="dFlex alignItemsCenter" style={{ gap: 4 }}>
      <Icon
        className="icon-square cursorDefault"
        style={{ fontSize: 13, color: item.color || '#9c9c9c' }}
      />
      {item?.isI18n ? <Translate value={item.label} /> : item?.scoreRangeName}
      {!!isOr && <Translate value="portfolioScore.or" />}
    </Element>
  )
}
